import { MaintenanceForwardingsCheckinEntryStepOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'

export const checkoutEntryOptions: {
  [K in MaintenanceForwardingsCheckinEntryStepOptions]: {
    title: string
  }
} = {
  [MaintenanceForwardingsCheckinEntryStepOptions.AutoEntry]: {
    title: 'Auto-locomoção',
  },
}
